import { LoginPage } from './login.auth';

const AuthConfig = {
  settings: {
    layout: {
      config: {},
    },
  },
  routes: [
    {
      path: '/login',
      element: <LoginPage />,
    },
  ],
};

export default AuthConfig;

